// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"text_pageTitle__kqczi","sectionTitle":"text_sectionTitle__SnPWD"};